import gqlClient from '../client/gqlClient';
import gql from 'graphql-tag';
import checkBrandUserSession from '../../brand_session';

export const mutationEditRequestCreate = async ({contentId, message}) => {
    try {
        if(!window.Cypress) await checkBrandUserSession();
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }
        return await gqlClient.client.mutate({
            mutation: gql`
                mutation editRequestCreate($input: EditRequestCreateInput!){
                    editRequestCreate(input: $input){
                        wasSuccessful
                        userErrors{
                            field,
                            message
                        }
                    }
                }
            `,
            variables: {
                input: {contentId: contentId, message: message},
            }
        });
    } catch (error) {
        console.error('Request edit post error: ', error);
    }
}

export const mutationInternalMessageCreate = async ({contentId, message}) => {
    try {
        if(!window.Cypress) await checkBrandUserSession();
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }
        return await gqlClient.client.mutate({
            mutation: gql`
                mutation internalMessageCreate($input: InternalMessageCreateInput!){
                    internalMessageCreate(input: $input){
                        wasSuccessful
                        userErrors{
                            field,
                            message
                        }
                    }
                }
            `,
            variables: {
                input: {contentId: contentId, message: message},
            }
        });
    } catch (error) {
        console.error('Internal message post error: ', error);
    }
}


// WEBPACK FOOTER //
// ./graphql/mutations/mutationEditRequestCreate.js